import React, { FC, memo } from 'react'

import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Box } from '@ucheba/ui/components/Box/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'

import TelegramIcon from '@ucheba/ui/icons/icon__telegram-filled.svg'

import { analyticEvent } from '@ucheba/utils/helpers/analytics/events'
import {
  EAnalyticEvents,
  EAnalyticEventTargets,
  EAnalyticSections,
} from '@ucheba/utils/helpers/analytics/events/types'
import admissionInstructionDesktopImage from '../assets/admissionInstructionDesktopImage.png'
import { IAdmissionInstructionProps } from '../types'
import { Container, Content, ButtonStyled, Image } from '../styles'

const AdmissionInstruction: FC<IAdmissionInstructionProps> = (props) => {
  const { institutionId, admissionInstruction } = props

  if (!(admissionInstruction && admissionInstruction.title)) return null

  const tgLink = `/events/tg-subscribe/registration?templateId=10032&institution_id=${institutionId}&utm_medium=vuz_page&utm_source=ucheba&utm_campaign=leadmagnit`

  return (
    <>
      <Box spacing='large' color='plum'>
        <Container>
          <Content>
            <Heading h2={admissionInstruction.title} spacing='xxsmall' />

            <Text lineHeight='h5' fontSize='h5'>
              {admissionInstruction.text}
            </Text>

            <Spacing spacing='small' />

            <ButtonStyled
              href={tgLink}
              onClick={() => {
                analyticEvent({
                  targets: [EAnalyticEventTargets.ym, EAnalyticEventTargets.ur],
                  eventName: EAnalyticEvents.admissionGuideBannerButtonClick,
                  section: EAnalyticSections.admissionGuideBanner,
                })
              }}
              color='gold'
              target='_blank'
              StartIcon={<TelegramIcon />}
            >
              Скачать в Telegram
            </ButtonStyled>
          </Content>

          <Image
            src={admissionInstructionDesktopImage}
            alt='как оценить шансы на поступление'
          />
        </Container>
      </Box>

      <Spacing spacing='uxlarge' />
    </>
  )
}

export default memo(AdmissionInstruction)
